import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { MessageService } from '@app/shared/services/common/message.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorhandlerService implements ErrorHandler {

  private last403At = 0;

  constructor(private router: Router, private notificationService: NotificationService, private messageService: MessageService) { }

  handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      // If unauthorized (401) or forbidden (403) response from backend
      const resetUrlToRedirect = window.location.pathname + window.location.search;
      if (error.status === 403) {
        const now = Date.now();
        if (now - this.last403At > 2000) {
          this.last403At = now;
          this.notificationService.error('You dont have sufficient permission to access the page', 'Auhtorization Error');
        }
        window.localStorage.setItem('urlToRedirect', resetUrlToRedirect);
      }
      else if (error.status === 401) {
        this.notificationService.error('Please login again', 'Session expired');
        if (localStorage.getItem('role') === 'SuperAdmin' || localStorage.getItem('role') === 'StoreAdmin'||localStorage.getItem('role') === 'CustomerService')
        {
          localStorage.clear();
          this.router.navigate(['/']);
        }
        else {
          const sch = JSON.parse(localStorage.getItem('colorScheme'));
          const storeUrl = localStorage.getItem('storeUrl');
          const socialUrls = JSON.parse(localStorage.getItem('SocialMediasUrl'));
          // As once user logout and re-login, we send store id at backend API. So fetching and again setting in local storage.
          const savestoreId = localStorage.getItem('storeId');
          localStorage.clear();
          localStorage.setItem('storeId', savestoreId);
          localStorage.setItem('colorScheme', JSON.stringify(sch));
          localStorage.setItem('SocialMediasUrl', JSON.stringify(socialUrls));
          this.router.navigate(['/', storeUrl]);
          const r = {
            profileImage: 'assets/img/default_user_img.png',
            profileName: '',
            userRole: '',
            cartItemCount: 0
          };
          this.messageService.sendMessage(r);
        }

        window.localStorage.setItem('urlToRedirect', resetUrlToRedirect);
      } else {
        this.notificationService.error('Something went wrong', 'Error');
      }
    } else {
      this.notificationService.error('Something went wrong', 'Error');
    }
  }
}
